<template>
    <Content class="home" style="background:rgba(249,249,249,1);">
        <div class="bgHome"></div>
        <Card>
            <Menu mode="horizontal" theme="light" class="menuHome" @on-select="onSelect">
                <div class="layout-nav">
                    <MenuItem v-for="(item,index) in columnList" :key="index" :name="index">
                        <Icon :type="item.icon" size="70" />
                        <span>{{item.title}}</span>
                    </MenuItem>
                </div>
            </Menu>
            <div class="memorial">
                <span style="width:276px;height:22px;font-size:30px;font-family:ArialMT;font-weight:400;color:rgba(153,153,153,1);">Memorial Hall</span><br/>
                <span style="width:103px;height:32px;font-size:32px;font-family:MicrosoftYaHei;font-weight:bold;color:rgba(51,51,51,1);">纪念馆</span><br/>
                <span style="color:rgba(0,157,233,1);">____</span>
                <div class="imgs" v-if="imgs != null">
                    <div v-for="(item,index) in imgs" :key="index" class="img-container" @click="toMem(item.memorialId)">
                        <img :src="item.headImage||imgDefault" :onerror="imgDefault">
                        <span class="deadName">{{item.deadName}}</span>
                    </div>
                </div>
                <div class="imgs" v-show="imgs == null" style="margin-left: 5px;">
                    <span style="font-size: 28px;">暂无图片</span>
                </div>
                <div class="more">
                    <Button type="primary" shape="circle" ghost to="/memorial">查看更多</Button>
                </div>
            </div>
            <div class="news">
                <span style="width:276px;height:22px;font-size:30px;font-family:ArialMT;font-weight:400;color:rgba(153,153,153,1);">News Center</span><br/>
                <span style="width:103px;height:32px;font-size:32px;font-family:MicrosoftYaHei;font-weight:bold;color:rgba(51,51,51,1);">新闻中心</span><br/>
                <span style="color:rgba(0,157,233,1);">____</span>
                <div class="news-container" v-if="newsLists != ''">
                    <div v-for="(item,index) in newsLists" :key="index" class="newsD" @click="toNewsDeta(item.newsId)">
                        <p>
                            <img :src="item.picUrl||imgDefault" :onerror="imgDefault">
                        </p>
                        <dl>
                            <dt>{{item.title}}</dt>
                            <dd class="summary">{{item.summary}}</dd>
                            <dd class="time">{{item.publishTime}}</dd>
                        </dl>
                    </div>
                </div>
                <div class="news-container" v-if="newsLists == ''" style="margin: 50px auto;">
                    <span style="font-size: 28px;">暂无新闻</span>
                </div>
                <div class="more">
                    <Button type="primary" shape="circle" ghost to="/news">查看更多</Button>
                </div>
            </div>
            <div class="contact">
                <span style="width:276px;height:22px;font-size:30px;font-family:ArialMT;font-weight:400;color:rgba(153,153,153,1);">CONTACT US</span><br/>
                <span style="width:103px;height:32px;font-size:32px;font-family:MicrosoftYaHei;font-weight:bold;color:rgba(51,51,51,1);">联系我们</span><br/>
                <span style="color:rgba(0,157,233,1);">____</span>
                <Row style="margin-top: 60px;">
                    <Col span="12">
                        <Form ref="formValidate" :label-width="1" :rules="ruleValidate" :model="formValidate">
                            <FormItem prop="name">
                                <Input type="text" placeholder="请输入您的姓名" v-model="formValidate.name">
                                    <Icon type="md-person" slot="prepend"/>
                                </Input>
                            </FormItem>
                            <FormItem prop="telephone">
                                <Input type="text" placeholder="请输入您的手机号码" v-model="formValidate.telephone">
                                    <Icon type="md-phone-portrait" slot="prepend"/>
                                </Input>
                            </FormItem>
                            <FormItem prop="address">
                                <Input type="text" placeholder="请输入您的地址" v-model="formValidate.address">
                                    <Icon type="md-pin" slot="prepend"/>
                                </Input>
                            </FormItem>
                            <FormItem prop="email">
                                <Input type="text" placeholder="请输入您的邮箱" v-model="formValidate.email">
                                    <Icon type="md-mail" slot="prepend"/>
                                </Input>
                            </FormItem>
                            <FormItem prop="content">
                                <Input type="textarea" :autosize="{minRows: 7.5}" placeholder="请输入您的留言" v-model="formValidate.content">
                                    <Icon type="md-list" slot="prepend"/>
                                </Input>
                            </FormItem>
                            <FormItem>
                                <Button type="primary" @click="save('formValidate')">提交</Button>
                                <Button style="margin-left: 8px" @click="reset('formValidate')">重填</Button>
                            </FormItem>
                        </Form>
                    </Col>
                    <Col span="10" offset="2">
                        <div style="text-align: left;line-height: 34px;">
                            上海飞思海葬服务有限公司  <br/>
                            地　　址：上海市虹口区西宝兴路833号(上海市宝兴殡仪馆)2号楼2楼<br/>

                            联系电话：021-66600544&nbsp;&nbsp;&nbsp;&nbsp;021-962840<br/>


                        </div>
                        <img src="../assets/map.png" width="350px" height="350px" align="left" />
                    </Col>
                </Row>
            </div>
        </Card>
    </Content>
</template>

<script>
    import api from '@/api/api'
    export default {
        name: 'home',
        data () {
            return {

                imgDefault: require('../assets/noimgs.jpg'),
                columnList: '',
                imgs:[],
                newsLists: '',
                formValidate: {
                    name: '',
                    telephone: '',
                    address: '',
                    email: '',
                    content: '',
                },
                ruleValidate: {
                    name: [
                        { required: true, message: '姓名不能为空', trigger: 'blur' }
                    ],
                    telephone: [
                        { required: true, message: '电话号码不能为空', trigger: 'blur' },
                        { min: 11, max: 11, message: '电话号码必须是11位数'}
                    ],
                    address: [
                        { required: false, message: '地址', trigger: 'blur' }
                    ],
                    email: [
                        { required: false, message: '邮箱', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '留言不能为空', trigger: 'blur' },
                    ],
                }
            }
        },
        mounted(){
            this.getColumnList();
            this.getMemorial();
            this.getNewsList();
        },
        methods: {
            // 服务分类信息
            getColumnList(){
                var _this = this;
                api.columnLists().then(res => {
                    _this.columnList = res;
                }).catch(error =>{
                    this.$Message.error('分类数据获取错误')
                });
            },
            // 获取纪念馆信息
            getMemorial(){
                api.getMemorialIndex().then(res => {
                    // console.log(JSON.stringify(res) + "---------")
                    this.imgs = res;
                })
            },
            // 获取新闻信息
            getNewsList(){
                api.newsCategory().then(res => {
                    var params = {"page":"0","pageSize":"3","categoryId":res[0].categoryId};
                    api.newsList(params).then(resp => {
                        this.newsLists = resp.rows;
                    })
                })

            },
            // 跳转
            onSelect(index){
                let columnId = this.columnList[index].columnId
                this.$router.push({
                    name: 'service', params: {columnId:columnId,index:index}
                })
            },
            // 纪念馆详细信息
            toMem(memorialId) {
                this.$router.push({
                    path: `/memorialDetail/${memorialId}`
                })
            },
            toNewsDeta(newsId) {
                this.$router.push({
                    name: 'newsDetail', params: {newsId: newsId}
                })
            },
            save(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        api.feedbackAdd(this.formValidate).then(res => {
                            this.$Message.success({
                                content: '提交成功',
                                duration: 3
                            });
                            this.$refs[form].resetFields();
                        }).catch(error => {
                            this.$Message.error('处理异常');
                        })

                    } else {
                        return;
                    }
                })
            },
            reset(form){
                this.$refs[form].resetFields();
            }
        },
        components: {}
    }
</script>

<style  lang="scss">
    .home{
        .layout {
            background: #f5f7f9;
            position: relative;
            overflow: hidden;
        }

        .bgHome {
            width: 100%;
            height: 360px!important;
            background: url("../assets/homeBg.png") no-repeat center!important;
            background-size: cover;
            -webkit-background-size: cover;
            -moz-background-size: cover;
        }

        .menuHome {
            display: -webkit-box;
            -webkit-box-pack: center;
            -webkit-box-align: center;
            margin: -90px auto 0px!important;
            height: 150px!important;
            min-width: 800px;
            max-width: 50%;
            background:rgba(255,255,255,1);
            box-shadow:0px 6px 6px 0px rgba(232,232,232,0.72);
            border-radius:6px;
            .ivu-menu-item {
                margin: 10px 32px 0px;
                color: #515a6e!important;
                border-bottom: 2px solid transparent!important;
                &:hover {
                    color: #2d8cf0!important;
                    .ivu-icon {
                        border: 1px solid #2d8cf0!important;
                    }
                    border-bottom: 2px solid transparent!important;
                }
            }
            .ivu-menu-item>i {
                padding: 8px;
                border-radius: 60px;
                box-shadow: 9px 11px 20px 0px rgba(228, 228, 228, 0.75);
                float: left;
                color: #2d8cf0;
                border: 1px solid #FFFFFF;
            }
            span {
                float: left;
                clear: both;
                font-size: 16px!important;
            }
        }

        .memorial {
            display: -webkit-box;
            -webkit-box-pack: center;
            -webkit-box-align: center;
            min-width: 800px;
            max-width: 50%;
            margin: 90px auto;
            position: relative;
            .imgs {
                margin: 30px;
                width: 100%;
                float: left;
                .img-container {
                    float: left;
                    margin: 0px 10px 10px;
                    width: calc(100%/3.5);
                    height: 265px;
                    overflow: hidden;
                    position: relative;
                    &:hover {
                        box-shadow: 0 0 10px  #999;
                        .deadName {
                            opacity: 1;
                            transform:translateY(0) ;
                        }
                    }
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .deadName {
                        opacity: 0;
                        transform:translateY(100%) ;
                        transition: all 0.5s;
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        font-size: 18px;
                        color: #FFFFFF;
                        background: rgba(gray,0.5);
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }
                }
                &:hover {
                    cursor: pointer;
                }
            }
            .more {
                position: absolute;
                bottom: -40px;
                left: 45.8%;
            }
        }

        .news {
            width:100%;
            margin: 90px auto;
            padding-top: 30px;
            padding-bottom: 30px;
            background-color: #F6F4FE;
            .news-container {
                display: -webkit-box;
                -webkit-box-pack: center;
                -webkit-box-align: center;
                float: left;
                width: 100%;
                .newsD {
                    margin: 31px 10px;
                    width: calc(100%/4.5);
                    min-height: 500px;
                    background-color: #FFFFFF;
                    dl{
                        position: relative;
                        padding: 17px 22px;
                        text-align: left;
                        dt {
                            height: 50px;
                            overflow: hidden;
                            font-size: 18px;
                            font-family:MicrosoftYaHei;
                            font-weight:400;
                            color:rgba(51,51,51,1);
                        }
                        dd {
                            font-size:14px;
                            font-family:MicrosoftYaHei;
                            font-weight:400;
                            color:rgba(150,150,150,1);
                            line-height: 20px;
                            margin-top: 19px;
                        }
                        .summary {
                            height: 100px;
                            overflow: hidden;
                        }
                        .time {
                            position: absolute;
                            color: #969696!important;
                            bottom: -10;
                        }
                    }
                    &:hover {
                        cursor: pointer;
                    }
                    p img{
                        width: 100%;
                        height: 253px;
                    }
                }
            }
        }

        .contact {
            width: 60%;
            margin: 80px auto;
        }
    }

</style>
